var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.92662C1.5 3.94871 3.98654 1.5 7.09715 1.5C10.2078 1.5 12.6943 3.94871 12.6943 6.92662C12.6943 8.40574 12.0809 9.7543 11.0822 10.7371C11.0703 10.7478 11.0587 10.759 11.0473 10.7707C11.0455 10.7725 11.0438 10.7744 11.042 10.7763C10.0331 11.7492 8.64211 12.3532 7.09715 12.3532C3.98654 12.3532 1.5 9.90454 1.5 6.92662ZM11.5579 12.3141C10.3364 13.2778 8.78245 13.8532 7.09715 13.8532C3.19689 13.8532 0 10.7712 0 6.92662C0 3.08203 3.19689 0 7.09715 0C10.9974 0 14.1943 3.08203 14.1943 6.92662C14.1943 8.57341 13.6078 10.0803 12.6306 11.265L15.6595 14.2125C15.9564 14.5014 15.9629 14.9762 15.674 15.2731C15.3851 15.5699 14.9103 15.5764 14.6134 15.2875L11.5579 12.3141Z",
    fill: "#9488A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cfd7fd88ac63b8ef4fbef5beb7fc8f80.svg";
export { ForwardRef as ReactComponent };